export const QUEUE_TYPE_OPTIONS = [
  { label: "Solo", value: "ranked_solo" },
  { label: "Flex", value: "ranked_flex" },
];

export const QUEUE_TYPE_MAP = {
  ranked_solo: [420],
  ranked_flex: [440],
};
